import { X } from "lucide-react";
import { DataCard } from "../../shared/DataCard";
import { useState } from "react";
import { useError } from "../../context/ErrorProvider";
import Loading from "../../shared/Loading";
import CustomInput from "../../shared/CustomInput";

const ReviewDisburseDetails = ({
  closeReviewDisburseDetails,
  handleRecordDisbursement,
  disburseDetails,
  loanApplication,
  loading,
  setDisburseDetails,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState("");
  const { showError } = useError();

  const handleNext = () => {
    if (!isChecked) {
      showError("Please confirm that the funds were disbursed offline below");
      return;
    }
    if (disburseDetails?.disburseType === "MPESA") {
      handleRecordDisbursement();
    }
  };

  const handleDateChange = (e) => {
    const date = e.target.value;

    setDisburseDetails({
      ...disburseDetails,
      disburseDate: date,
    });
  };
  return (
    <div
      onClick={(e) => {
        closeReviewDisburseDetails();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[800px] h-[500px] rounded-[10px] py-[20px] px-[40px] relative bg-[#F3F3F3] border"
      >
        <div
          onClick={closeReviewDisburseDetails}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div>
          <p className="text-[#000000] font-semibold text-[20px]">
            Complete Disburse Funds
          </p>
          <p className="text-[#5C5C5C] font-normal text-[14px]">
            Please review all details before proceeding with disbursement.
            Transfer the funds using your usual method (e.g. bank, M-PESA). Once
            done, click Next to record the transaction details in the system.
            Funds are not automatically sent from this system.
          </p>
          <div className="flex items-center my-[10px] justify-between">
            <div className="flex w-[49%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Borrower’s Name"
              >
                Borrower’s Name
              </label>
              <DataCard
                myData={`${loanApplication?.customer?.firstname} ${loanApplication?.customer?.lastname}`}
              />
            </div>
            <div className="flex w-[49%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="M-PESA Phone Number"
              >
                M-PESA Phone Number
              </label>
              <DataCard myData={disburseDetails?.phoneNumber ?? "N/A"} />
            </div>
          </div>
          <div className="flex items-center my-[10px] justify-between">
            <div className="flex w-[49%] flex-col">
              <label
                className="text-[#222222] font-medium text-[13px]"
                htmlFor="Disbursement Amount (KES)"
              >
                Disbursement Amount (KES)
              </label>
              <DataCard myData={loanApplication?.loanAmount ?? 0} />
            </div>
          </div>
        </div>
        <div className="flex items-center my-[10px] mt-8 justify-between">
          <div className="flex w-full flex-col">
            <label
              className="text-[#222222] font-medium text-[13px]"
              htmlFor="Disbursement Amount (KES)"
            >
              Disburse Date
            </label>
            <CustomInput
              placeholder="e.g Enter disburse date"
              type="date"
              value={disburseDetails.disburseDate}
              onChange={handleDateChange}
            />
            {error && (
              <span className="text-red-500 text-[12px] mt-1">{error}</span>
            )}
          </div>
        </div>
        <div className="absolute bottom-[80px] left-[40px] flex items-center gap-[8px] right-[20px]">
          <input
            type="checkbox"
            name="confirm"
            id="confirm"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
          />
          <p className="text-[#5C5C5C] text-[13px] font-normal">
            I confirm that the funds have been disbursed offline and the details
            provided are accurate.
          </p>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeReviewDisburseDetails}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            disabled={loading || !isChecked || !disburseDetails.disburseDate}
            onClick={handleNext}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loading && <Loading />}
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewDisburseDetails;
